/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type GetQuizsetRankingsPeriod =
  (typeof GetQuizsetRankingsPeriod)[keyof typeof GetQuizsetRankingsPeriod];

export const GetQuizsetRankingsPeriod = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
} as const;
